module.exports = __webpack_public_path__ + "img/copy.fa6bb90a.svg";